// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu_b5128","menuSpacer":"Menu_menuSpacer_afeb1"};